import React from 'react';
import { SearchInput } from '../../common/SearchInput';
import { DateRangePicker } from 'rsuite';
import { isAfter } from 'date-fns';
import './PaymentTransactionsFilterSection.scss';

interface Props {
	searchValue: string,
	setSearchValue: (value: string) => void,
	date: any,
	setDate: (date: any) => void,
}

export const ClientsLogsFilterSection = (props: Props): React.ReactElement => {
	const { searchValue, date, setDate, setSearchValue } = props;
	return (
		<div className="card mb-5 mb-xl-8 bg-transparent">
			<div className="card-body py-0 px-0 payment-transactions-display justify-content-between align-items-center">
				<div className="d-flex align-items-center block-width application-selector payment-transactions">
					<SearchInput
						placeholder="Search order id / ordersession key"
						additionalClass="w-50"
						searchValue={searchValue}
						setSearchValue={setSearchValue}
					/>
				</div>
				<div className="date-filter-box d-flex justify-content-end payment-transactions">
					<DateRangePicker
						showOneCalendar
						placeholder="Filter by dates"
						placement="bottomEnd"
						onChange={(value): void => setDate(value)}
						onClean={(): void => setDate([])}
						shouldDisableDate={(date): boolean => isAfter(date, new Date())}
						value={date}
						// ranges={[]}
					/>
				</div>
			</div>
		</div>
	);
};
